<template>
  <div :class="['previewMain',{disScroll:loading}]">
    <!--loading-->
    <div class="loadingBox" v-if="loading">
      <van-loading size="24px" text-size="25px" color="#448af7">附件加载中，请稍候。</van-loading>
    </div>
    <!--导航-->
    <div class="topNav" v-if="showNav">
          <span class='topBackBtn' @click="returnPage">
            <van-icon name="arrow-left"/>
          </span>
    </div>

    <!--附件预览-->
    <div class="previewBox">
      <!--返回按钮-->
      <img src="../../assets/img/close.png" :class="['returnBtn',{setarea:showNav}]"
           @click="returnPage"
           v-if="showBackBtn">

      <vue-office-docx v-if="fileType==='docx'||fileType==='doc'" :src="url" @rendered="rendered" @error="error"/>
      <vue-office-excel v-if="fileType==='xlsx'||fileType==='xls'" :src="url" @rendered="rendered" @error="error"/>
      <div v-if="fileType==='pdf'">
        <van-icon class='arrowLeft' name="arrow-left" @click="lastPage"/>
        <van-icon class='arrowRight' name="arrow" @click="nextPage"/>
        <span class="pdfPage">{{ pageNum }}/{{ pageTotalNum }}</span>
        <pdf id="pdfPreview" ref="pdfArea" :src="url" :page="pageNum"
             @num-pages="pageTotalNum=$event"
             @page-loaded="pageLoaded($event)"></pdf>
      </div>
    </div>
  </div>
</template>

<script>
import VueOfficeDocx from '@vue-office/docx'
import '@vue-office/docx/lib/index.css'
import VueOfficeExcel from '@vue-office/excel'
import '@vue-office/excel/lib/index.css'
import VueOfficePdf from '@vue-office/pdf'
import pdf from 'vue-pdf'
import {Toast} from 'vant'
import {getConfig} from '../../util/auth'

export default {
  name: 'attachmentPreview',
  components: {
    VueOfficeDocx,
    VueOfficeExcel,
    VueOfficePdf,
    pdf
  },
  data () {
    return {
      showNav: false, // 是否展示导航栏
      showBackBtn: false, // 是否展示返回按钮
      loading: false,
      fileInfo: {},
      fileType: '',
      url: '',
      pageNum: 1, // pdf当前页
      pageTotalNum: 1 // pdf总页数
    }
  },
  methods: {
    // 获取附件数据
    getFileInfo () {
      this.loading = true
      let fileTypeArr = ['docx', 'doc', 'pdf', 'xlsx', 'xls']
      this.fileInfo = JSON.parse(this.$route.query.file)
      // 判断附件类型
      fileTypeArr.forEach(item => {
        let fileNameInfo = this.fileInfo.csdrAttName
        let currentType = fileNameInfo.substring(fileNameInfo.lastIndexOf('.') + 1)

        // 判断附件类型
        if (currentType === item) {
          this.fileType = item
        }
      })

      // 赋值附件url
      if (this.fileInfo.csdrAtt.indexOf('http') === -1) {
        this.url = this.$originApi + this.fileInfo.csdrAtt
      } else {
        this.url = this.fileInfo.csdrAtt
      }
    },
    // 返回
    returnPage () {
      this.$router.push({
        path: '/'
      })
    },
    // 渲染完成
    rendered () {
      this.loading = false
      // 设置word样式宽度保持全屏
      this.setWordStyle()
    },
    // 渲染失败
    error () {
      this.loading = false
      Toast.fail('文件加载失败')
    },
    // 是否展示返回按钮
    getConfigInfoFn () {
      let configInfo = getConfig()
      if (configInfo) {
        this.showNav = configInfo.setting.settingsShowNavigationBar
        this.showBackBtn = configInfo.setting.settingsShowBackButton
      }
    },
    // 方法一：改变initial-scale
    // 设置word样式宽度保持全屏，leave参数用于判断是否离开本页面，离开leave为true则恢复initial-scale为1.0
    setDocxStyle (leave) {
      if (leave) {
        let updatedContent = 'width=device-width,initial-scale=1.0,maximum-scale=1.0, user-scalable=0,viewport-fit=cover'
        let metaTag = document.querySelector('meta[name="viewport"]')
        metaTag.setAttribute('content', updatedContent)
      } else {
        let wordWrapper = document.getElementsByClassName('docx-wrapper')[0]
        if (wordWrapper) {
          let formatDecimal = function (num, decimal) {
            num = num.toString()
            var index = num.indexOf('.')
            if (index !== -1) {
              num = num.substring(0, decimal + index + 1)
            } else {
              num = num.substring(0)
            }
            return parseFloat(num).toFixed(decimal)
          }
          let intw = document.getElementsByClassName('docx')[0].offsetWidth
          let winw = window.screen.width
          let metaTag = document.querySelector('meta[name="viewport"]')
          let updatedContent = 'width=' + (winw >= intw ? intw : winw) + ',initial-scale=' + formatDecimal(winw / intw, 2) + ',viewport-fit=cover'
          metaTag.setAttribute('content', updatedContent)
          document.getElementsByTagName('head')[0].cssText = 'width:' + intw + 'px;overflow-x:hidden'
        }
      }
    },
    // 方法二：用transform仅改变div的缩放
    // 设置word样式宽度保持全屏，leave参数用于判断是否离开本页面
    setWordStyle (leave) {
      if (leave) {
        let updatedContent = 'width=device-width,initial-scale=1.0,maximum-scale=1.0, user-scalable=0,viewport-fit=cover'
        let metaTag = document.querySelector('meta[name="viewport"]')
        metaTag.setAttribute('content', updatedContent)
      } else {
        let updatedContent = 'width=device-width,initial-scale=1.0,viewport-fit=cover'
        let metaTag = document.querySelector('meta[name="viewport"]')
        metaTag.setAttribute('content', updatedContent)

        let wordWrapper = document.getElementsByClassName('docx-wrapper')[0]
        if (wordWrapper) {
          let formatDecimal = function (num, decimal) {
            num = num.toString()
            var index = num.indexOf('.')
            if (index !== -1) {
              num = num.substring(0, decimal + index + 1)
            } else {
              num = num.substring(0)
            }
            return parseFloat(num).toFixed(decimal)
          }
          let intw = document.getElementsByClassName('docx')[0].offsetWidth
          let winw = window.screen.width
          let scaleNum = formatDecimal(winw / intw, 2)
          wordWrapper.style.transform = 'scale(' + scaleNum + ')'
          wordWrapper.style.transformOrigin = 'top left'
        }
      }
    },
    // pdf下一页
    nextPage () {
      var p = this.pageNum
      p = p < this.pageTotalNum ? p + 1 : 1
      this.pageNum = p
    },
    // pdf上一页
    lastPage () {
      var p = this.pageNum
      p = p > 1 ? p - 1 : this.pageTotalNum
      this.pageNum = p
    },
    // pdf当前页加载完成
    pageLoaded (e) {
      this.loading = false
      // 设置word样式宽度保持全屏
      this.setWordStyle()
    }
  },
  created () {
    // 获取附件数据
    this.getFileInfo()
    // 是否展示返回按钮
    this.getConfigInfoFn()
  },
  beforeDestroy () {
    // 恢复页面禁止缩放
    this.setWordStyle(true)
  }
}

</script>

<style scoped>
.previewMain {
  overflow-y: auto;
  position: relative;
}

.disScroll {
  overflow: hidden;
}

.loadingBox {
  position: absolute;
  background: black;
  width: inherit;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 99999;
  opacity: 0.7;
}

.previewBox {
  overflow: hidden;
  height: 100vh;
}

.topNav {
  position: relative;
  top: 0;
  z-index: 99999;
  background: #fff;
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.van-loading {
  top: 40%;
  left: 15%;
}

.returnBtn {
  width: 25px;
  position: fixed;
  left: 2px;
  top: 2px;
  z-index: 99999;
  opacity: 0.8;
}

.setarea {
  top: 42px;
}

.vue-office-docx {
  overflow-x: auto;
}

/deep/ .docx-wrapper {
  width: fit-content !important;
  min-width: 100%;
}

.topBackBtn {
  font-size: 18px;
  position: absolute;
  left: 5px;
}

/deep/ table.docx_a3 td {
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.arrowLeft {
  display: inline-block;
  padding: 2px;
  font-size: 28px;
  position: absolute;
  top: 40%;
  left: 5px;
  z-index: 999;
  color: #777777;
}

.arrowRight {
  display: inline-block;
  padding: 2px;
  font-size: 28px;
  position: absolute;
  top: 40%;
  right: 5px;
  z-index: 999;
  color: #777777;
}

.pdfPage {
  position: absolute;
  bottom: 50px;
  left: 0;
  right: 0;
  z-index: 999;
  color: #7b7b7b;
  margin: 0 auto;
  display: inline-block;
  width: 50px;
  font-size: 14px;
}

#pdfPreview {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/chat/attachmentPreview.vue